import { css, keyframes } from 'styled-components';
const reset = keyframes `
  100% {
    transform: translate(0%, 0%);
    opacity: 1;
  }
`;
export function fadeInLeft(amount, duration, delay, easingFunc) {
    return css `
    opacity: 0;
    transform: translateX(-${amount}px);
    animation: ${reset} ${duration}ms ${delay}ms ${easingFunc} forwards;
  `;
}
export function fadeInRight(amount, duration, delay, easingFunc) {
    return css `
    opacity: 0;
    transform: translateX(${amount}px);
    animation: ${reset} ${duration}ms ${delay}ms ${easingFunc} forwards;
  `;
}
export function fadeIn(inView, duration, delay, easingFunc) {
    return css `
    transition: opacity ${duration}ms ${delay}ms ${easingFunc};

    ${inView
        ? css `
          opacity: 1;
        `
        : css `
          opacity: 0;
        `}
  `;
}
export function fadeInUp(inView, amount, duration, delay, easingFunc) {
    return css `
    transition: transform ${duration}ms ${easingFunc} ${delay}ms, opacity ${duration}ms ${easingFunc} ${delay}ms;

    ${inView
        ? css `
          opacity: 1;
          transform: translateY(0px);
        `
        : css `
          opacity: 0;
          transform: translateY(${amount}px);
        `}
  `;
}
export function greyscaleImgFade(inView, duration, delay, filterDelay, easingFunc) {
    return css `
    transition: opacity ${duration}ms ${delay}ms ${easingFunc}, filter ${duration}ms ${filterDelay}ms ${easingFunc};

    ${inView
        ? css `
          opacity: 1;
          filter: grayscale(0);
        `
        : css `
          opacity: 0;
          filter: grayscale(1);
        `}
  `;
}
export const animateLeadingLine = keyframes `
  0% {
    transform: translate(-50%, 50%) scaleY(0);
    transform-origin: 0 0;
  }

  33% {
    transform: translate(-50%, 50%) scaleY(1);
    transform-origin: 0 0;
  }

  40% {
    transform: translate(-50%, 50%) scaleY(1);
    transform-origin: 0 0;
  }

  40.01% {
    transform-origin: 100% 100%;
  }

  60% {
    transform-origin: 100% 100%;
    transform: translate(-50%, 50%) scaleY(0);
  }
`;
export const animateLeadingLineNoOffset = keyframes `
  0% {
    transform: translate(-50%, 0) scaleY(0);
    transform-origin: 0 0;
  }

  33% {
    transform: translate(-50%, 0) scaleY(1);
    transform-origin: 0 0;
  }

  40% {
    transform: translate(-50%, 0) scaleY(1);
    transform-origin: 0 0;
  }

  40.01% {
    transform-origin: 100% 100%;
  }

  60% {
    transform-origin: 100% 100%;
    transform: translate(-50%, 0) scaleY(0);
  }
`;
const shimmerKeyframes = keyframes `
    0% {
      background-position: -1000px 0;
    }
    100% {
      background-position: 1000px 0;
    }
`;
const shimmer = css `
  animation: ${shimmerKeyframes} 2s infinite linear;
  background: linear-gradient(to right, #eff1f3 4%, #e2e2e2 25%, #eff1f3 36%);
  background-size: 1000px 100%;
`;
const spinKeyframes = keyframes `
    from {
        transform:rotate(0deg);
    }
    to {
        transform:rotate(360deg);
    }
`;
const skeletonBackgroundShine = keyframes `
  0% {
      background-position: -100% 0;
  }

  50%, 100% {
      background-position: 100% 0;
  }
`;
export const skeletonComponentBackground = (backgroundColor, shineColor) => css `
  background: linear-gradient(
    to right,
    ${backgroundColor ?? 'rgba(130, 130, 130, 0.2)'} 8%,
    ${shineColor ?? 'rgba(130, 130, 130, 0.3)'} 18%,
    ${backgroundColor ?? 'rgba(130, 130, 130, 0.2)'} 33%
  );
  background-size: 200% 100%;
  animation: ${skeletonBackgroundShine} 2s infinite ease-out;
`;
export const cubicEaseOut = `cubic-bezier(0.33, 1, 0.68, 1)`;
export const shouldAnimate = (innerCss) => {
    return css `
    @media (prefers-reduced-motion: no-preference) {
      ${innerCss}
    }
  `;
};
export const transition = (properties, duration = 0.35, timing = cubicEaseOut) => {
    return shouldAnimate(css `
    transition-duration: ${typeof duration === 'string' ? duration : `${duration}s`};
    transition-property: ${properties};
    transition-timing-function: ${timing};
    will-change: ${properties};
  `);
};
export default {
    easeInOutCubic: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    easeOutCubic: `cubic-bezier(0.3, 0.1, 0.1, 0.7)`,
    rootMargin: '0px 0px -20% 0px',
    shimmer,
    spinKeyframes,
};
